/** Сообщение после оплаты с пересчётом посещений */
export function activationSuccessMessage(activation) {
  if (!activation || !activation.charged) {
    return "Оплата принята, абонемент активирован";
  }
  const n = activation.charged;
  const rest = activation.visits_remaining;
  const word =
    n % 10 === 1 && n % 100 !== 11
      ? "занятие"
      : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
        ? "занятия"
        : "занятий";
  return `Абонемент активирован. Списано ${n} ${word} за предыдущие тренировки. Остаток: ${rest ?? "—"}.`;
}

export function activationWarningMessage(activation) {
  const conflicts = activation?.conflicts?.length ?? 0;
  const skipped = activation?.skipped ?? 0;
  if (!conflicts && !skipped) return null;
  if (conflicts > 0) {
    return `${conflicts} посещ. уже списаны по другому абонементу — пропущены`;
  }
  return null;
}
